import useDataLayer from "@/utils/useDataLayer";
import OpenIcon from "@/Icons/icon-dpo-open.svg";

const Apply = ({ dpoSettings, dpoQuote, trackingRef }) => {
  const [pushEvent] = useDataLayer();
  const {
    sku,
    profile,
    labelHeight: height,
    labelWidth: width,
    cornerRadius,
    labelShape: shape,
    addWhiteColor = '',
  } = dpoQuote;

  const {
    design_with_quote_endpoints: { standard, custom_size },
  } = dpoSettings;

  const endPoint = profile === 'sticker' ? custom_size : standard;

  let queryParams = {
    sku,
    source: "ApplyDesign",
    addWhiteColor: addWhiteColor === 'Y',
  };

  if (profile === 'sticker') {
    queryParams = { ...queryParams, height, width, cornerRadius, shape };
  }

  return (
    <div id="apply"
      className="flex flex-col flex-wrap bg-neutral-light border-2 border-neutral-dark cursor-pointer font-semibold text-center text-xs tablet:text-sm shadow-[shadow:var(--theme-card-shadow)] hover:ring-1 hover:ring-[color:var(--theme-link-border-color-4)] hover:border-[color:var(--theme-link-border-color-4)]"
    >
      <form
        method="POST"
        encType="multipart/form-data"
        onSubmit={() => {
            pushEvent({
                event: "triggerEvent",
                eventCategory: "DPO",
                eventAction: "Configurator-Apply",
                eventLabel: "Apply-Start"
            });

            if (trackingRef.current) {
                trackingRef.current.trackStartDesigningCta('Open Saved Design');
            }
          }
        }
        action={`${endPoint}&${Object.keys(queryParams)
          .map((key) => key + '=' + queryParams[key])
          .join('&')}`}
        className="h-full"
      >
      <button className="flex flex-col w-full h-full">
        <div className="flex flex-col gap-xs items-center justify-center w-full bg-white p-lg laptop:flex-row">
          <div className="mx-3xs h-[4rem] w-[4rem]">
            <OpenIcon />
          </div>
          <div className="laptop:text-left">
            <div className="text-2xl font-semibold">
              {Drupal.t(
                'Apply',
                {},
                { context: 'DPO Apply' }
              )}
            </div>
            <div className="text-xs font-semibold">
              {Drupal.t('Designs / Templates')}
            </div>
          </div>
        </div>
        <ul
          className="list-disc text-left pl-2xl pr-xl my-sm"
          dangerouslySetInnerHTML={{
            __html: Drupal.t(
              '<li>Use one of your previously saved designs</li><li>Apply that design to a new label shape or size</li>'
            ),
          }}
        ></ul>
      </button>
        <textarea style={{ display: 'none' }} id="quote" name="quote" value={JSON.stringify(dpoQuote)} readOnly>
        </textarea>
      </form>
    </div>
  );
};

export default Apply;
